<template>
  <v-layout v-if="campaign" wrap>
    <v-flex xs12>
      <CampaignFieldsCard
        v-bind="{
          fields: campaignFields,
          campaign,
          save,
          deleteCampaign,
          cancel,
        }"
      />
    </v-flex>
    <transition name="fade--slow">
      <v-flex v-if="history.length" xs12 campaign-history__header>
        <v-subheader>HISTORY</v-subheader>
      </v-flex>
    </transition>
    <transition-group name="list-transition" tag="div" class="flex xs12">
      <CampaignHistoryCard
        v-for="entry in history"
        :key="entry.id"
        v-bind="entry"
      />
    </transition-group>
  </v-layout>
</template>

<script>
import CampaignFieldsCard from "@/components/CampaignFieldsCard";
import CampaignHistoryCard from "@/components/CampaignHistoryCard";
import queryMapResolver from "@/mixins/queryMapResolver";
import { mapGetters } from "vuex";
import URI from "urijs";

export default {
  components: {
    CampaignFieldsCard,
    CampaignHistoryCard,
  },
  mixins: [queryMapResolver],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["queryMap"]),
    ...mapGetters("campaigns", { campaign: "active" }),
    ...mapGetters("queryMaps", ["queryMap"]),
    ...mapGetters("history", ["historyByCampaign"]),
    ...mapGetters("fields", ["campaignFields"]),
    ...mapGetters("spaces", { currentSpace: "active" }),
    isNew() {
      return this.id === "new";
    },
    history() {
      return this.campaign ? this.historyByCampaign(this.campaign.id) : [];
    },
  },
  created() {
    this.$store.commit("campaigns/activate", this.id);
    this.campaign || this.$router.push({ name: "campaigns" });
    if (!this.isNew) {
      this.$store.dispatch("history/findAll", {
        campaign_id: this.campaign.id,
      });
    }
  },
  methods: {
    async save(campaign = {}) {
      const { links, field_values } = campaign;
      var nestedLinks = null;
      if (this.queryMap.firebase_enabled) {
        const firebase_queries = this.resolveFirebaseQueryMap(
          this.queryMap,
          field_values
        );
        nestedLinks = this.parseLinks(campaign.url_encoded, links, firebase_queries);
      }
      const queries = this.resolveQueryMap(this.queryMap, field_values);
      let parsedLinks = [];
      if (nestedLinks) {
        nestedLinks.forEach((nestedLink) => {
          queries["link"] = nestedLink;
          parsedLinks.push(
            this.parseLinks(campaign.url_encoded, this.queryMap.firebase_host, queries)[0]
          );
        });
      } else {
        parsedLinks = this.parseLinks(campaign.url_encoded, links, queries);
      }

      await this.saveCampaign(this.campaign.id, campaign);
      parsedLinks.length && this.addHistoryEntry(parsedLinks);
    },
    parseLinks(urlEncoded, links, queries) {
      Object.keys(queries).forEach(
        (key) => !queries[key] && delete queries[key]
      );
      let parsedLinks = [];
      links.split("\n").forEach((row) => {
        const link = row.trim();
        if (link) {
          if (urlEncoded) {
            // %26 instead of & and %3D instead of =
            const parameters = Object.entries(queries).map(query => {
              return query[0] + '%3D' + query[1];
            });
            let newLink = link;
            const pos = newLink.indexOf('?');
            if (pos == -1) {
              newLink += '?';
            }
            const uri = newLink + parameters.join('%26');
            parsedLinks.push(uri);
          } else {
            const uri = URI(link).addQuery(queries);
            parsedLinks.push(uri.href());
          }
        }
      });
      return parsedLinks;
    },
    async saveCampaign(id, body) {
      const space_id = this.currentSpace.id;
      const campaign = { id, space_id, ...body };
      await this.$store.dispatch("campaigns/save", campaign);
      this.isNew &&
        this.$router.push({
          name: "campaign",
          params: { id: this.campaign.id },
        });
    },
    addHistoryEntry(links) {
      return this.$store.dispatch("history/save", {
        campaign_id: this.campaign.id,
        links,
      });
    },
    async deleteCampaign(id) {
      await this.$store.dispatch("campaigns/delete", id);
      var current_space_id = this.currentSpace.id;
      this.$router.push({ name: "campaigns", params: { current_space_id } });
    },
    cancel() {
      var current_space_id = this.currentSpace.id;
      this.$router.push({ name: "campaigns", params: { current_space_id } });
    },
  },
};
</script>

<style lang="scss">
.campaign-history__header {
  margin-top: 20px;
}
</style>
